import { Button, Typography } from "@avenue-8/sidekick-ui";
import {
  NeighborhoodMapProperty,
  PropertyPhoto,
} from "@cma/presentation-generation-logic";
import { getPropertyMarkerColorByType } from "@cma/presentation-generation-logic/shared/properties-map-utils";
import { useImageGalleryStore } from "@cma/store/image-gallery.store";
import styled from "@emotion/styled";
import { memo } from "react";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  align-items: center;
  padding: 0 0.5rem;
`;

const AddressText = styled(Typography)`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 0.5rem;
  font-size: ${(p) => p.theme.text.fontSizes.l};
`;

const InnerMarkerColor = styled.span<{ $markerColor: string }>`
  background-color: ${(p) => (p.$markerColor ? p.$markerColor : "transparent")};
  height: 0.675rem;
  width: 0.675rem;
  border-radius: 2em;
`;

interface PropertyDetailProps {
  property: NeighborhoodMapProperty;
  gallery?: PropertyPhoto[];
}

export const PropertyDetail = memo((props: PropertyDetailProps) => {
  const { property, gallery } = props;
  const setGalleryImages = useImageGalleryStore(
    (store) => store.setGalleryImages
  );

  const galleryPhotos =
    gallery?.map((photo, i) => ({
      id: `id-${i}`,
      url: photo.url,
      alt: photo.caption || `Property photo ${i}`,
    })) || [];

  return (
    <Container>
      <AddressText>
        <InnerMarkerColor
          $markerColor={getPropertyMarkerColorByType(property.type)}
        />
        {property.tooltip}
      </AddressText>
      {galleryPhotos.length > 0 && (
        <>
          <Button
            onClick={() => setGalleryImages({ images: galleryPhotos })}
            variant="text"
            size="small"
          >
            Show Photos
          </Button>
        </>
      )}
    </Container>
  );
});

PropertyDetail.displayName = "PropertyDetail";
